import { Pipe, PipeTransform } from "@angular/core";
import { Subject, distinctUntilChanged } from "rxjs";
import { FileApi } from "../../../domain/api/file.api";
import { UUID } from "../../../domain/model/entityReference.model";

@Pipe({ name: "filePath", standalone: true, pure: false })
export class FilePipe implements PipeTransform {
	private data = "";
	private readonly fileIdSubject = new Subject<UUID>();

	constructor(private readonly fileApi: FileApi) {
		this.fileIdSubject
			.pipe(distinctUntilChanged())
			.subscribe(async (id: string) => {
				await this.fileApi.fetch(id);
				const fetchedFile = this.fileApi.syncById(id);
				this.data = fetchedFile ? fetchedFile.filePath : "";
			});
	}

	transform(fileId: string): string {
		if (!fileId) {
			this.data = "";
			return this.data;
		}

		const file = this.fileApi.syncById(fileId);

		if (!file) {
			this.fileIdSubject.next(fileId as UUID);
		} else {
			this.data = file.filePath;
		}
		return this.data;
	}
}
